import { ContactProvider } from "@/context/ContactContext";
import { ProductDetailProvider } from "@/context/ProductDetailContext";
import { ClientProvider } from "@/context/ClientContext";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Catalog from "@/components/Catalog";
import Manifesto from "@/components/Manifesto";
import ContactFooter from "@/components/ContactFooter";
import ContactModal from "@/components/ContactModal";
import ProductDetail from "@/components/ProductDetail";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function HomePage() {
  return (
    <ClientProvider>
      <ContactProvider>
        <ProductDetailProvider>
        <SmoothScroll>
          <div className="min-h-screen bg-[#0B1712] text-white antialiased selection:bg-[color:var(--dp-orange)] selection:text-black">
            <Header />
            <main>
              <Hero />
              <Marquee />
              <Catalog />
              <Manifesto />
              <ContactFooter />
            </main>
            <ContactModal />
            <ProductDetail />
            <WhatsAppButton />
          </div>
        </SmoothScroll>
        </ProductDetailProvider>
      </ContactProvider>
    </ClientProvider>
  );
}
